import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class ResearchShowcaseParticipant extends BaseModel {
  static override constructorName = 'ResearchShowcaseParticipant'

  id: number = 0
  fio: string = ''
  photo: string = ''
  role: string = ''
  description: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.photo = toCroppedImage(this.photo)
    }
  }
}

registerModel(ResearchShowcaseParticipant)
